// Navbar.js
import { Box, Flex, HStack, Text, Button, Image, Link } from "@chakra-ui/react";

export default function Navbar({ chatStarted }) {
  return (
    <Box 
      position="fixed" 
      top={0} 
      left={0} 
      right={0} 
      zIndex={1000}
      boxShadow="sm"
    >
      <Flex
        px="clamp(16px, 1.5vw, 32px)"
        py="clamp(10px, 0.8vw, 18px)" 
        bg="white"
        borderBottom="1px solid #ECECEC"
        alignItems="center"
        justifyContent="space-between"
        height="clamp(60px, 4.5vh, 80px)"
      >
        {/* Logo */}
        <Link href="https://app.alpherra.com/" isExternal>
          <Image 
            src="/logoHeader.svg" 
            alt="Logo" 
            h="clamp(24px, 2vw, 38px)" 
          />
        </Link>

        {/* Right Side */}
        <HStack spacing="clamp(12px, 1vw, 24px)">
          {/* {!chatStarted ? (
            <>
              <Button
                variant="ghost"
                fontSize="clamp(14px, 1vw, 18px)"
                fontWeight="medium"
                color="#242424"
                px="clamp(16px, 1.2vw, 28px)"
                py="clamp(8px, 0.6vw, 14px)"
                h="clamp(36px, 3vh, 48px)"
                borderRadius="12px"
                _hover={{ bg: "#F5F5F5" }}
              >
                Sign Up
              </Button>
              <Button
                bg="#CF008A"
                color="white"
                fontSize="clamp(14px, 1vw, 18px)"
                fontWeight="semibold"
                px="clamp(16px, 1.2vw, 28px)"
                py="clamp(8px, 0.6vw, 14px)"
                h="clamp(36px, 3vh, 48px)"
                borderRadius="12px"
                _hover={{ bg: "#D933A1" }}
              >
                Sign In
              </Button>
            </>
          ) : ( */}
          {/* CHAT MODE: User avatar */}
          <Flex
            w="clamp(34px, 2.5vw, 48px)"
            h="clamp(34px, 2.5vw, 48px)"
            bg="#CF008A"
            color="white"
            borderRadius="50%"
            alignItems="center"
            justifyContent="center"
            fontWeight="bold"
            fontSize="clamp(14px, 1.2vw, 20px)"
          >
            A
          </Flex>
          {/* )} */}
        </HStack>
      </Flex>
    </Box>
  );
}
